import { render, staticRenderFns } from "./geneaology.vue?vue&type=template&id=5fcdaacc&scoped=true&"
import script from "./geneaology.vue?vue&type=script&lang=js&"
export * from "./geneaology.vue?vue&type=script&lang=js&"
import style0 from "./geneaology.vue?vue&type=style&index=0&id=5fcdaacc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcdaacc",
  null
  
)

export default component.exports